import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  create_calendar_availability_action,
  user_meta_data_action,
} from "../../../../redux/_actions";

function useCalendarOnBoard() {
  const [formInputsError, setFormInputsError] = useState({});
  const [googleLoader, setGoogleLoader] = useState(false);
  const [calendarLinked, setCalendarLinked] = useState({});
  const [userMeta, setUserMeta] = useState();

  const user_token =
    localStorage.getItem("jigsawUser") &&
    JSON.parse(localStorage.getItem("jigsawUser"));
  const dispatch = useDispatch();

  const { calendarLinkedData } = useSelector(
    (state) => state.check_google_calendar_linked_data_reducer
  );

  const { userMetaData } = useSelector((state) => state.user_meta_data_reducer);

  useEffect(() => {
    if (calendarLinkedData) {
      setCalendarLinked(calendarLinkedData);
    }
  }, [calendarLinkedData]);

  useEffect(() => {
    if (userMetaData) {
      setUserMeta(userMetaData);
    }
  }, [userMetaData]);

  useEffect(() => {
    callUserMetaAction();
  }, []);

  const callUserMetaAction = async () => {
    await dispatch(user_meta_data_action());
  };

  const google_login = React.useCallback(() => {
    const googleAuthUrl = "https://accounts.google.com/o/oauth2/v2/auth";
    const redirectUri = `${process.env.REACT_APP_BACKEND_API_URL}/calendar-auth/google-oauth/callback/`;
    const scope = ["https://www.googleapis.com/auth/calendar.events"].join(" ");
    const params = {
      response_type: "code",
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      redirect_uri: `${redirectUri}`,
      access_type: "offline",
      state: user_token.user.id,
      include_granted_scope: true,
      scope,
    };
    const urlParams = new URLSearchParams(params).toString();
    window.location = `${googleAuthUrl}?${urlParams}`;
  }, []);

  return {
    calendarLinked,
    googleLoader,
    formInputsError,
    userMeta,

    google_login,
  };
}

export default useCalendarOnBoard;
